import request from '../request';

import { logout, login, forgotPassword, resetPassword, register } from './config';
import type {
    ForgotPasswordBody,
    LoginParams,
    ResetPasswordBody,
    SetPasswordBody,
    VerifyOtpBody
} from './helpers/helpers';

const api = {
    register(body: any) {
        return request
            .post(register, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    login(body: LoginParams) {
        return request
            .post(login, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    logout() {
        return request
            .get(logout)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    forgotPassword(body: ForgotPasswordBody) {
        return request
            .post(forgotPassword, body)
            .then((res) => res.data)
            .catch((error) => {
                // console.log('error', error);
                throw error;
            });
    },
    resetPassword(body: ResetPasswordBody) {
        return request
            .post(resetPassword, body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    verifyOtp(body: VerifyOtpBody) {
        return request
            .post('/auth/verify-otp', body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    resendOtp() {
        return request
            .post('/auth/resend-otp', {})
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    setPassword(body: SetPasswordBody) {
        return request
            .post('/auth/set-password', body)
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    getPasswordStatus() {
        return request
            .get('/auth/password-status')
            .then((res) => res.data)
            .catch((error) => {
                throw error;
            });
    },
    /** Does this email belong to an account that still has to choose a password? */
    accountStatus(email: string): Promise<{ needsSetup: boolean }> {
        return request
            .post('/auth/account-status', { email })
            .then((res) => res.data)
            .catch(() => ({ needsSetup: false }));
    },
    checkSession() {
        return request
            .get('/auth/session-check')
            .then((res) => res.data)
            .catch(() => ({ authenticated: false }));
    }
};

export default api;
